export default [{
		path: 'index',
		component: () => import('../../views/platform/meCourse'),
		meta: {
			title: '首页'
		}
	},{
		path: 'meCourse',
		component: () => import('../../views/platform/meCourse'),
		meta: {
			title: '我的课程'
		}
	},
	{
		path: 'helpCenter',
		component: () => import('../../views/platform/helpCenter'),
		meta: {
			title: '帮助中心'
		}
	}
]